import { v4 as uuidv4 } from 'uuid';

import { Asset } from '@rover/types/src/ImagePicker';

import { MediaType } from './types';

/** A Media file available for the app to use. The result of selecting media. */
export default class MediaFile {
  /** UUID */
  id: string;

  /** URI path to media file */
  uri: string;

  /** The original selected file object for this media */
  file: Asset;

  type: MediaType;

  size: number;

  name: string;

  constructor(asset: Asset) {
    const file = asset as File;

    // Make sure we're dealing with an image or video file
    if (!asset.type?.startsWith('image') && !asset.type?.startsWith('video')) {
      throw new Error('MediaFiles may only be constructed from image or video files');
    }

    this.uri = URL.createObjectURL(asset as Blob);
    this.id = uuidv4();
    this.file = asset;
    this.type = asset.type.startsWith('image') ? MediaType.IMAGE : MediaType.VIDEO;
    this.size = file.size;
    this.name = file.name;
  }
}
